<template>
  <div class="widget_part">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.widget_part {
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 10px;

  height: 100%;
  margin: 0;
  box-sizing: border-box;
}

.widget_part:first-child {
  border-right: 1px dashed #fc5a0a;
}

.widget.mobile .widget_part:first-child {
  border: none !important;
  width: 100% !important;
}

.widget.mobile .widget_part:last-child {
  display: none;
}
</style>
